import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'monthly', 'option', 'yearly'];
  static classes = ['hidden'];

  connect() {
    const billingPeriod = new URL(window.location.href).searchParams.get('billing_period');
    this.#update(billingPeriod === 'year' ? 'year' : 'month');
  }

  change(event) {
    this.#update(event.target.value);

    const url = new URL(window.location.href);
    url.searchParams.set('billing_period', event.target.value);
    window.history.replaceState(window.history.state, '', url);
  }

  #update(billingPeriod) {
    const yearly = billingPeriod === 'year';

    this.optionTargets.forEach((option) => {
      option.checked = option.value === billingPeriod;
    });
    this.monthlyTargets.forEach((element) => element.classList.toggle(this.hiddenClass, yearly));
    this.yearlyTargets.forEach((element) => element.classList.toggle(this.hiddenClass, !yearly));
    this.inputTargets.forEach((input) => {
      input.value = billingPeriod;
    });
  }
}
